import { init, thumbnailDecorator } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { injectWebComponentScript, closeSearch } from "./helpers"
import { defaultConfig } from "./config"

import "./styles/index.css"

/* for dev site */
export const devSite = window.Shopify?.shop === 'beginning-boutique-dev.myshopify.com';
const isSearchPage = location.href.includes('/collections/search')

if(
    devSite && 
    location.pathname.includes('/collections') && 
    !document.getElementById('nosto-collection')
) {
    const targetEl = document.createElement('div');
    targetEl.id = "nosto-collection";
    document.getElementById('MainContent')?.appendChild(targetEl);
}

injectWebComponentScript();

init({
    ...window.nostoTemplatesConfig,
    preservePageScroll: true,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: "input.site-header-search__input",
    formCssSelector: 'form[role="search"]',
    contentCssSelector: devSite ? '#nosto-collection' :'.nosto-product-grid',
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    serpPath: '/collections/search',
    serpPathRedirect: window.location.pathname !== "/collections/search",
    serpQuery: {
        products: {
            fields: [
                "productId", "url",
                "name", "ratingValue", "tags1", 
                "thumbUrl", "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id",
                "skus.customFields.key", "skus.customFields.value"
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId", "url",
                "name", "ratingValue", "tags1", 
                "thumbUrl", "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id",
                "skus.customFields.key", "skus.customFields.value",
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    persistentSearchCache: true,    
    // Uncomment for Category Merchandising
    categoryCssSelector: devSite ? '#nosto-collection' :'.nosto-product-grid',
    isCategoryPage: () => {
        const path = window.location.pathname;
        return path.includes("/collections/") && !path.includes("/collections/search")
    },
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                fields: [
                    "productId", "url",
                    "name", "ratingValue", "tags1", 
                    "thumbUrl", "imageUrl", "alternateImageUrls",
                    "brand", "availability",
                    "price", "listPrice",
                    "customFields.key", "customFields.value",
                    "skus.name", "skus.price", "skus.listPrice",
                    "skus.availability", "skus.id",
                    "skus.customFields.key", "skus.customFields.value",
                ],
                categoryId: this.categoryId(),
                // categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
})
.then(() => {
    // adjustments for search toggles
    const selectors = [
        // mobile
        {
            newInputId: 'nosto-search-input-mobile',
            input: document.querySelector('.navbar-search-mobile #ss-search-input-mobile'),
            label: document.querySelector('.navbar-search-mobile .field__label[for="ss-search-input"]'),
            btn: document.querySelector('.navbar-search-mobile .field__button[aria-label="Search"]'),
        },
        // desktop
        {
            newInputId: 'nosto-search-input',
            input: document.querySelector('.navbar-search-desk #ss-search-input'),
            label: document.querySelector('.navbar-search-desk .field__label[for="ss-search-input"]'),
            btn: document.querySelector('.navbar-search-desk .field__button[aria-label="Search"]'),
        }
    ];

    selectors.forEach(({ input, label, btn, newInputId }, index) => {
        if (input && label) {
            input.after(label);
            input.id = newInputId;
            label.htmlFor = newInputId;
        }
        if (btn) {
            btn.type = 'submit';
        }
    });

    const mobileSearchToggle = document.querySelector('.mobile__search--icon');
    if(mobileSearchToggle) {
        mobileSearchToggle.addEventListener('click', (event) => {
            event.preventDefault();
            setTimeout(() => {
                const searchInput = document.getElementById("nosto-search-input-mobile");
                if (searchInput) {
                    searchInput.focus();
                }
            }, 100);
        })
    }

    const mobileMenuToggle = document.getElementById('Details-menu-drawer-container')
    if(mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', (e) => {
            if(!mobileMenuToggle.open) {
                document.querySelector('.navbar-search-mobile')?.click() //force close history dropdown
            }
        })
    }

    // close search overlay if on search results page
    if(isSearchPage) {
        const mobileInput = document.getElementById('nosto-search-input-mobile');
        if(mobileInput) {
            mobileInput.addEventListener('keydown', (e) => {
                if(e.key === 'Escape' || e.key === 'Enter') {
                    closeSearch();
                    window.scrollTo(0, 0)
                }
            })
        }
    
        const mobileSubmit = document.querySelector('.navbar-search-mobile .field__button[aria-label="Search"]');
        if(mobileSubmit) {
            mobileSubmit.addEventListener('click', () => {
                closeSearch();
                window.scrollTo(0, 0)
            })
        }
    }

    // found on native site
    const descEl = document.querySelector('.top-description');
    const toggleBtn = document.querySelector('.toggle-description-btn');
    if (descEl && toggleBtn){    
        const fullHTML = descEl.dataset.full;
        const shortText = descEl.dataset.short;
    
        let expanded = false;
    
        toggleBtn.addEventListener('click', () => {
            expanded = !expanded;
            descEl.innerHTML = expanded ? fullHTML : shortText;
            toggleBtn.textContent = expanded ? 'Read less' : 'Read more';
        });
    }
})